export { CAMPAIGN_CATEGORIES } from './marketplaceCategories';

export const PLATFORM_TYPES = [
  'Instagram',
  'TikTok',
  'Whatnot',
];

export const FEE_MODEL_TYPES = [
  { value: 'commission_rate', label: 'Commission Rate' },
  { value: 'flat_rate', label: 'Flat Rate' },
  { value: 'hourly_rate', label: 'Hourly Rate' },
];

export const BRAND_REVENUE_OPTIONS = [
  'Pre-revenue',
  '$0\u2013100K',
  '$100K\u2013500K',
  '$500K\u20131M',
  '$1M+',
];

/** Brand social handle fields — keep in sync with brands table columns and profile forms. */
export const BRAND_PLATFORM_HANDLE_FIELDS = Object.freeze([
  { key: 'tiktok', label: 'TikTok username', platform: 'TikTok' },
  { key: 'instagram', label: 'Instagram username', platform: 'Instagram' },
  { key: 'whatnot', label: 'Whatnot username', platform: 'Whatnot' },
]);

export function sanitizeBrandHandle(value) {
  if (typeof value !== 'string') return '';
  return value.startsWith('@') ? value.substring(1) : value;
}
